$ = require 'jquery'
{ forEach, map } = require 'lodash'

###
@dependsOn jquery
@dependsOn velocity
@dependsOn lodash
###
module.exports =
class AnimationSequence

  ###
  create AnimationSequence instance


  ###
  constructor: ->

  ###
  initialize
  @param initialVals [Array] animation initial vals

  @example initialVals array
    [
      {
        e: '.sapmle'
        p: { display: 'none' }
      }
    ]
  ###
  initialize: (initialVals) =>
    return unless initialVals
    forEach initialVals, (obj) =>
      el = obj.e

      setCss = ($el) ->
        $el.css obj.p

      @switchingByType el, setCss

  ###
  animation sequence
  @param sequences [object] animation sequences
  @param name [String] sequence name
  @param beforeFn [function] before function
  @param afterFn [function] after function

  @example sequences object
    {
      name: [
        {
          e: '.sample'
          p: { opacity: 1 }
          o: { duration: 500, display: 'block' }
        }
      ]
    }
  ###
  runSequence: (sequences, name, beforeFn = undefined, afterFn = undefined) =>
    return unless sequences
    len = sequences[name].length
    unless len
      beforeFn?()
      afterFn?()
      return
    $.Velocity.RunSequence map sequences[name], (obj, i) =>
      el = obj.e

      getObj = ($el) ->
        _obj =
          elements  : $el
          properties: obj.p
          options   : obj.o
        if i is 0
          _obj.options.begin = beforeFn
        if (len - 1) is i
          _obj.options.complete = afterFn
        _obj

      @switchingByType el, getObj

  ###
  loop animation sequence
  @param sequences [object] animation sequences
  @param names [Array] sequence names
  @param interval [Number] sequence interval
  ###
  loopSequences: (sequences, names, interval = 0) ->
    timer = {}
    runSequences = (sequences, names, interval) =>
      forEach names, (name) =>
        clearTimeout timer?[name]
        timer[name] = setTimeout =>
          @runSequence sequences, name, null, =>
            runSequences sequences, names, interval
        , interval
    runSequences sequences, names, interval

  ###
  @private
  @param el [String|jQueryObject|HTMLElement|Array] element
  ###
  switchingByType: (el, fn) ->
    if el instanceof Array
      forEach el, ($el) ->
        fn $el
    else
      $el =
        if el instanceof jQuery then el else $(el)
      fn $el



// WEBPACK FOOTER //
// ./webpack/requires/components/animation-sequence.coffee